const ModelCreate = () => import("@/components/Admin/Model/ModelCreate");
const ModelEdit = () => import("@/components/Admin/Model/ModelEdit");
const ModelView = () => import("@/components/Admin/Model/ModelView");

const routes = [
  {
    name: "ModelCreate",
    path: "/projects/:projectId/models/create",
    component: ModelCreate,
    meta: {
      title: "Create model",
      sidebar: true
    }
  },
  {
    name: "ModelEdit",
    path: "/projects/:projectId/models/:modelId/edit",
    component: ModelEdit,
    meta: {
      title: "Edit model",
      sidebar: true
    }
  },
  {
    name: "ModelView",
    path: "/projects/:projectId/models/:modelId",
    component: ModelView,
    meta: {
      title: "View model",
      sidebar: true
    }
  }
];

export default routes;
